// src/components/common/ToastContainer.js
import React from 'react';
import { ToastContainer as ReactToastifyContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

/**
 * Toast Container Component
 * Add this component to your App.js (or root component) to enable toasts globally
 *
 * Example usage in App.js:
 * import { ToastContainer } from './components/common/ToastContainer';
 *
 * function App() {
 *   return (
 *     <>
 *       <YourApp />
 *       <ToastContainer />
 *     </>
 *   );
 * }
 */
export const ToastContainer = ({
    position = 'top-right',
    autoClose = 3000,
    hideProgressBar = false,
    newestOnTop = true,
    closeOnClick = true,
    rtl = false,
    pauseOnFocusLoss = true,
    draggable = true,
    pauseOnHover = true,
    theme = 'light',
    limit,
    ...otherProps
}) => {
    return (
        <ReactToastifyContainer
            position={position}
            autoClose={autoClose}
            hideProgressBar={hideProgressBar}
            newestOnTop={newestOnTop}
            closeOnClick={closeOnClick}
            rtl={rtl}
            pauseOnFocusLoss={pauseOnFocusLoss}
            draggable={draggable}
            pauseOnHover={pauseOnHover}
            theme={theme}
            limit={limit}
            {...otherProps}
        />
    );
};

export default ToastContainer;
